import styled from '@emotion/styled';
import { SharedEventTypeListItem } from 'presentations/api/schema/event_type';
import UserEventTypeListItem, {
  LoadingComponent,
} from 'presentations/views/components/molecules/UserEventTypeListItem';
import { mediaMax, spacing } from 'presentations/views/styles';

interface Props {
  teamSlug: string;
  eventTypes: SharedEventTypeListItem[];
  isLoading?: boolean;
}
export default function Component(props: Props) {
  if (props.isLoading) {
    return (
      <List>
        <LoadingComponent />
        <LoadingComponent />
      </List>
    );
  }
  return (
    <List>
      {props.eventTypes.map((eventType) => (
        <ListItem key={eventType.uid}>
          <UserEventTypeListItem
            key={eventType.id}
            teamSlug={props.teamSlug}
            eventType={eventType}
          />
        </ListItem>
      ))}
    </List>
  );
}

const List = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: ${spacing(24)};
  ${mediaMax.tablet} {
    display: block;
  }
`;
const ListItem = styled.div`
  ${mediaMax.tablet} {
    margin-bottom: ${spacing(16)};
    :last-of-type {
      margin-bottom: 0;
    }
  }
`;
